import React, { useState, useMemo } from "react"
import { Flex, Box, Radio, Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react"
import Icon from "@components/Icon/Icon"

const PerPageMobile: React.FC = props => {
  const [isOpen, setIsOpen] = useState(false)

  const pageOptions = useMemo(() => {
    return [12, 24, 48, 96]
  }, [])

  return (
    <Flex w="100%" position="relative">
      <Accordion w="100%" allowToggle={true}>
        <AccordionItem w="100%">
          <AccordionButton w="100%">
            <Flex w="100%" fontSize="16px" fontWeight={"medium"} alignItems={"center"} onClick={() => setIsOpen(!isOpen)} cursor="pointer">
              Items per page
              <Box ml="auto" transform={isOpen ? "rotateX(180deg)" : "rotateX(0deg)"}>
                <Icon ml="10px" name="chevronDown" size="14px" color="black"></Icon>
              </Box>
            </Flex>
          </AccordionButton>
          <AccordionPanel pb={1}>
            <Flex flexDirection={"column"}>
              {pageOptions.map((option: any, idx: number) => (
                <Flex
                  onClick={() => {
                    // something
                    props.setPerPage(option)
                  }}
                  textTransform={"capitalize"}
                  cursor="pointer"
                  key={idx}
                  _first={{ mt: 2 }}
                  _last={{ mb: 2 }}
                  my={1}
                  fontWeight="medium"
                  whiteSpace={"nowrap"}
                  fontSize={"14px"}
                >
                  <Radio isChecked={props.perPage === option} size="lg" variant="primary" mr={1}></Radio>
                  {option}
                </Flex>
              ))}
            </Flex>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Flex>
  )
}

export default PerPageMobile
